
<template>
  <div class="company-details">
    <!--General Top Bar -->
    <!-- <general-top-bar :title="$t('settingsPages.companyDetails')"></general-top-bar> -->
    <!--End General Top Bar -->
    <div class="settings-top-bar sticky-header" ref="optionsTopBar">
      <div class="top-bar">
        <p></p>
        <p class="">
          <button type="submit" class="btn btn-icon btn-success btn mar-rt-10 save"  @click.prevent="validate" :title="$t('general.saveChanges')">
            <img src="/static/img/icons/save.png">
            {{$t('general.save')}}
          </button>
        </p>
      </div>
    </div>
    <div ref="compDetailsContainer" class="mar-to-15" :style="{height: windowHeight - pageTopHeight - navbarHeaderHeight - 1 + 'px'}">
      <div :class="(loading ? 'show-loader' : 'hide-loader')">
        <div class="el-loading-spinner">
          <svg viewBox="25 25 50 50" class="circular">
            <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
          </svg>
        </div>
      </div>
      <div class="card location-card">
        <div class="card-content">
          <form class="clearfix row">
            <div class="col-md-12">
              <p>{{$t('settingCompany.title')}}</p>
              <hr class="sm">
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>{{$t('settingCompany.name')}}</label>
                <input type="text" name="name" :placeholder="$t('settingCompany.name')" v-model="model.name" v-validate="modelValidate.name" class="form-control">
              </div>
              <div class="form-group">
                <label>{{$t('settingCompany.email_feedback')}}</label>
                <input type="text" name="email_feedback" :placeholder="$t('settingCompany.email_feedback')" v-model="model.email_feedback" v-validate="modelValidate.email_feedback" class="form-control">
                <small class="form-text text-muted">{{$t('settingCompany.email_feedback_helptext')}}</small>
              </div>
              <div class="form-group">
                <label>{{$t('settingCompany.lang')}}</label>
                <select
                  class="form-control"
                  placeholder=" - Select Language - "
                  v-model="model.language"
                  v-validate="modelValidate.language">
                  <option v-for="(label, key) in languages"
                    :value="key"
                    :label="label"
                    :key="key">
                    {{label}}
                  </option>
                </select>
                <small class="text-danger" v-if="errors.has('language')">
                  {{ getError('language') }}
                </small>
              </div>
              <div class="form-group">
                <label>{{$t('settingCompany.overEighteen')}}</label>
                <br/>
                <p-switch v-model="model.over_eighteen" type="success"></p-switch>
              </div>
            </div>

            <div class="col-lg-6 col-md-6">
              <div class="form-group">
                <label>{{$t('general.logo')}}</label>
                <el-upload
                  action=""
                  ref="uploadLogo"
                  :limit="2"
                  :file-list="imagelistLogo"
                  list-type="picture-card"
                  accept=" .jpg, .jpeg, .png, .svg, .webp"
                  :on-change="handleImgChangeLogo"
                  :on-exceed="handleExceed"
                  :on-remove="handleRemoveLogo"
                  :auto-upload="false">
                  <img src="/static/img/icons/icon-plus-primary.png">
                  <div class="el-upload__tip" slot="tip">{{$t('validations.pictureLogo')}}</div>
                </el-upload>
              </div>
              <div class="form-group">
                <label>{{$t('general.appImage')}}</label>
                <el-upload
                  action=""
                  ref="uploadAppImage"
                  :limit="2"
                  :file-list="imagelistAppImage"
                  list-type="picture-card"
                  accept=" .jpg, .jpeg, .png, .svg, .webp"
                  :on-change="handleImgChangeAppImage"
                  :on-exceed="handleExceed"
                  :on-remove="handleRemoveAppImage"
                  :auto-upload="false">
                  <img src="/static/img/icons/icon-plus-primary.png">
                  <div class="el-upload__tip" slot="tip">{{$t('validations.pictureLogo')}}</div>
                </el-upload>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="card location-card">
        <div class="card-content">
          <p>{{$t('settingCompany.deliveryLabels')}}</p>
          <hr class="sm">
          <div class="row">
            <div class="pad-bt-15 col-md-6" v-for="labelObj in model.delivery_options_labels">
              <label > {{$t('settingCompany.' + labelObj['key'])}} </label>
              <input
                class="form-control"
                type="text"
                v-validate="{required: true}"
                v-model="labelObj['label']">
            </div>
          </div>
        </div>
      </div>

      <div class="card location-card">
        <div class="card-content">
          <p>{{$t('settingCompany.orderStatus')}}</p>
          <hr class="sm">
          <form class="clearfix row">
            <div class="col-lg-6 col-md-6 ">
              <div class="form-group">
                <label>{{$t('settingCompany.allowSoundAtStatusNew')}}</label>
                <br/>
                <p-switch v-model="model.is_allowed_sound_at_new" type="success"></p-switch>
              </div>
            </div>

            <div class="col-lg-6 col-md-6 ">
              <div class="form-group">
                <label>{{$t('settingCompany.addStatusOnHold')}}</label>
                <br/>
                <p-switch v-model="model.is_allowed_on_hold" type="success"></p-switch>
              </div>
            </div>

            <div class="col-lg-6 col-md-6 ">
              <div class="form-group">
                <label>{{$t('settingCompany.addStatusPostponed')}}</label>
                <br/>
                <p-switch v-model="model.is_allowed_postponed" type="success"></p-switch>
              </div>
            </div>

            <div class="col-lg-6 col-md-6 ">
              <div class="form-group">
                <label>{{$t('settingCompany.automatedProcessedStatus')}}</label>
                <br/>
                <p-switch v-model="model.automated_processed_status" type="success"></p-switch>
              </div>
            </div>

            <div class="col-lg-6 col-md-6 ">
              <div class="form-group">
                <label>{{$t('settingCompany.allowSoundAtStatusProcessing')}}</label>
                <br/>
                <el-select
                  style="width: 100%"
                  v-model="model.is_allowed_sound_at_processing"
                  :placeholder="$t('settingCompany.allowSoundAtStatusProcessing')">
                    <el-option
                      key="is_allowed_sound_at_processing1"
                      :label="$t('settingCompany.allowSoundAtStatusProcessingV1')"
                      value="1">
                    </el-option>
                    <el-option
                      key="is_allowed_sound_at_processing2"
                      :label="$t('settingCompany.allowSoundAtStatusProcessingV2')"
                      value="2">
                    </el-option>
                    <el-option
                      key="is_allowed_sound_at_processing3"
                      :label="$t('settingCompany.allowSoundAtStatusProcessingV3')"
                      value="3">
                    </el-option>
                    <el-option
                      key="is_allowed_sound_at_processing0"
                      :label="$t('settingCompany.allowSoundAtStatusProcessingV0')"
                      value="0">
                    </el-option>
                </el-select>
              </div>
            </div>

            <div class="col-lg-6 col-md-6 ">
              <div class="form-group">
                <label>{{$t('settingCompany.allowSoundForMehods')}}</label>
                <v-select
                  v-model="model.sound_delivery_methods"
                  multiple
                  :options="deliveryMethods"
                  class="line-heigth-44"
                  :placeholder="$t('general.all')">
                </v-select>
              </div>
            </div>


             <div class="col-lg-6 col-md-6 ">
              <div class="form-group">
                <label>{{$t('settingCompany.alertMultipleOrders')}}</label>
                <input
                  type="number"
                  step="1"
                  min="5"
                  max="500"
                  :placeholder="$t('settingCompany.alertMultipleOrdersNr')"
                  class="form-control"
                  v-model="model.alert_multiple_orders_per_hour">
                </input>
              </div>
            </div>

            <div class="col-lg-6 col-md-6 ">
              <div class="form-group">
                <div class="mb-3 w-100">
                  <label class="form-label text-start w-100">{{$t('settingCompany.initalOrderStatusApp')}}</label>
                  <v-select
                    v-model="model.initial_order_status_app_web"
                    :options="orderStatusOptions"
                    label="label"
                    :placeholder="$t('ordersStatus.NEW')"
                    class="w-100 white mar-bt-15 line-heigth-44"
                    :key="'has-receipt-select'"
                  />
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div class="card-containerf1">
        <div class="card location-card 50-width">
          <div class="card-content">
            <div class="flex-container">
              <p>{{$t('settingsTips.tipsLabel')}}</p>
              <p-switch v-model="model.tips_in_use" type="success" class="mar-bt-0"></p-switch>
            </div>
            <hr class="mar-to-5">
            <form class="clearfix row">
              <div class="col-lg-12 col-md-12">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>{{$t('settingsTips.tipsVat')}}</label>
                    <select
                      v-if="model && taxesVersion === 2"
                      v-model="model.tips_vat_rate_id"
                      class="form-control">
                      <option :value="null">{{ $t('vat.selectVat') }}</option>
                      <option
                        v-for="vat in vatOptions"
                        :key="vat.id"
                        :value="vat.id"
                        :disabled="!vat.is_active && String(vat.id) !== String(model.tips_vat_rate_id)"
                      >{{ vat.rate }}%{{ !vat.is_active ? ' (inactiv)' : '' }}
                      </option>
                    </select>
                    <select
                      v-else-if="model"
                      v-model="model.tips_taxes"
                      class="form-control">
                      <option value="null">{{ $t('vat.selectVat') }}</option>
                      <option
                        v-for="vat in vatOptions"
                        :value="vat.id"
                        :id="vat.id"
                      >{{ vat.amount }}
                      </option>
                      <option style="display: none" :value="model.tips_taxes" v-if="model.tips_taxes !== null">{{ model.tips_taxes }}</option>
                    </select>
                    <small class="text-danger" v-if="Array.isArray(model.tips_taxes) && errors.has('tips_taxes')">
                        {{ getError('tips_taxes') }}
                    </small>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>{{$t('catalogProd.posid')}}</label>
                    <input
                      type="string"
                      :placeholder="$t('catalogProd.posid')"
                      class="form-control"
                      v-model="model.tips_pos_id">
                    <small class="text-danger" v-if="errors.has(model.tips_pos_id)">
                      {{ getError(model.tips_pos_id) }}
                    </small>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>{{$t('general.tips_department_id')}}</label>
                    <input 
                      type="string" 
                      :placeholder="$t('general.tips_department_id')"
                      class="form-control" 
                      v-model="model.tips_department_id">
                    <small class="text-danger" v-if="errors.has(model.tips_department_id)">
                      {{ getError(model.tips_department_id) }}
                    </small>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>

        <div class="card location-card 50-width">
          <div class="card-content">
            <p>{{$t('settingCompany.sortProductsMethods')}}</p>
            <hr class="mar-to-15">
            <form class="clearfix row">
              <div class="col-md-12">
                <div class="form-group">
                  <!-- <label class="inline-flex">{{$t('settingCompany.sortProductsMethods')}} <template v-if="model.sort_product_method === 'custom'">{{$t('settingCompany.infoCustomSort')}} </template></label> -->
                  <!-- <br/> -->
                  <select name="sort_products_method" class="form-control" v-model="model.sort_product_method">
                    <option v-for="(opt, key) in sortMethodsList"
                                :value="key"
                                :selected="key === model.sort_product_method">{{$t('settingCompany.'+key)}}</option>
                  </select>
                </div>
              </div>
            </form>
          </div>
        </div>

        <div class="card location-card width-50">
          <div class="card-content">
            <p>{{$t('settingCompany.languages')}}</p>
            <hr class="sm">
            <form class="clearfix row">
              <div class="clearfix form-group">
                <div class="col-lg-8 col-md-8">
                  <v-select
                    v-model="model.selected_languages"
                    multiple
                    :options="dbLanguagesOptions"
                    :placeholder="$t('general.all')">
                  </v-select>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div class="card location-card">
        <div class="card-content">
          <p>{{$t('settingCompany.preferences')}}</p>
          <hr class="sm">
          <form class="clearfix row">
            <div class="col-lg-6 col-md-6 ">
              <div class="form-group">
                <div class="mb-3 w-100">
                  <label class="form-label text-start w-100">{{$t('settingCompany.initalOrderStatusKiosk')}}</label>
                  <v-select
                    v-model="initalOrderStatusKiosk"
                    :options="selfOrderStatusOptions"
                    label="label"
                    :placeholder="$t('ordersStatus.NEW')"
                    class="w-100 white mar-bt-15 line-heigth-44"
                    :key="'has-receipt-select'"
                  />
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 ">
              <div class="form-group">
                <label>{{$t('settingCompany.allowPlaceUntilCloseHour')}}</label>
                <br/>
                <p-switch v-model="model.allow_order_until_close_hour" type="success"></p-switch>
              </div>
            </div>

            <div class="col-lg-6 col-md-6 ">
              <div class="form-group">
                <label>{{$t('settingCompany.removeTotalsExtrasFromDiscount')}}</label>
                <br/>
                <p-switch v-model="model.remove_totals_extras_from_discount" type="success"></p-switch>
              </div>
            </div>

            <div class="col-lg-6 col-md-6 ">
              <div class="form-group">
                <label>{{$t('settingCompany.allow_fiscal_print')}}</label>
                <br/>
                <p-switch v-model="model.print_fiscal_from_dashboard" type="success"></p-switch>
              </div>
            </div>

            <div class="col-lg-6 col-md-6 ">
              <div class="form-group">
                <label>{{$t('settingCompany.payment_btns_v2')}}</label>
                <br/>
                <p-switch v-model="model.payment_btns_v2" type="success"></p-switch>
              </div>
            </div>

            <div class="col-lg-6 col-md-6 ">
              <div class="form-group">
                <label>{{$t('settingCompany.just_card_txt_to_kiosk')}}</label>
                <br/>
                <p-switch v-model="model.just_card_txt_to_kiosk" type="success"></p-switch>
              </div>
            </div>

            <div class="col-lg-6 col-md-6 ">
              <div class="form-group">
                <label>{{$t('settingCompany.add_packing_method_to_comment')}}</label>
                <br/>
                <p-switch v-model="model.add_packing_method_to_comment" type="success"></p-switch>
              </div>
            </div>

            <div class="col-lg-6 col-md-6 ">
              <div class="form-group">
                <label>{{$t('settingCompany.allowToOrderUnderMinValueWithCoupon')}}</label>
                <br/>
                <p-switch v-model="model.is_allowed_order_under_min_value" type="success"></p-switch>
              </div>
            </div>

            <div class="col-lg-6 col-md-6 ">
              <div class="form-group">
                <label>{{$t('settingCompany.useGrandTotalForDeliveryZoneShippingCost')}}</label>
                <br/>
                <p-switch v-model="model.use_order_grandtotal_for_shipping_discount" type="success"></p-switch>
              </div>
            </div>

            <div class="col-lg-6 col-md-6 ">
              <div class="form-group">
                <label>{{$t('settingCompany.flagFastOrderFromAdmin')}}</label>
                <br/>
                <p-switch v-model="model.flag_fast_order_from_admin" type="success"></p-switch>
              </div>
            </div>

            <div class="col-lg-6 col-md-6 ">
              <div class="form-group">
                <label>{{$t('settingCompany.jump_to_categories_menu')}}</label>
                <br/>
                <p-switch v-model="model.jump_to_menu" type="success"></p-switch>
              </div>
            </div>

            <div class="col-lg-6 col-md-6 ">
              <div class="form-group">
                <label>{{$t('settingCompany.purchase_limit_interval_hours')}}</label>
                <br/>
                <input 
                      type="number" 
                      :placeholder="$t('settingCompany.purchase_limit_interval_hours')"
                      class="form-control"
                      v-model="model.purchase_limit_interval_hours">
              </div>
            </div>

            <div class="col-lg-12" style="clear: both;"></div>

            <!-- <div class="col-lg-6 col-md-6" style="clear: both;">
              <div class="row">
                <div class="col-lg-6 col-md-6">
                  <div class="form-group">
                    <label>{{$t('settingCompany.donationPointValue')}}</label>
                    <input
                      type="number"
                      :placeholder="$t('settingCompany.donationPointValueNr')"
                      class="form-control"
                      step="0.1"
                      v-model="model.donation_point_value">
                  </div>
                </div>
              </div>
            </div> -->

            <div class="col-lg-6 col-md-6">
            </div>
          </form>
        </div>
      </div>

      <div class="card-containerf1">
        <div class="card location-card width-50">
          <div class="card-content">
            <p>{{$t('settingCompany.unavailableRestaurantTitle')}}</p>
            <hr class="sm">
            <form class="clearfix row">
              <div class="col-lg-6 col-md-6" style="clear: both;">
                <div class="form-group">
                  <label>{{$t('settingCompany.unavailableRestaurantText')}}</label>
                  <textarea
                    rows="6"
                    :placeholder="$t('settingCompany.unavailableRestaurantTextPlaceHolder')"
                    class="form-control"
                    v-model="model.unavailable_text">
                  </textarea>
                </div>
              </div>

              <div class="col-lg-6 col-md-6">
                <div class="form-group">
                  <label>{{$t('settingCompany.unavailableRestaurantImage')}}</label>
                  <el-upload
                    action=""
                    ref="upload"
                    :limit="2"
                    :file-list="imagelist"
                    list-type="picture-card"
                    accept=" .jpg, .jpeg, .png"
                    :on-change="handleImgChnage"
                    :on-exceed="handleExceed"
                    :on-remove="handleRemove"
                    :auto-upload="false">
                    <img src="/static/img/icons/icon-plus-primary.png">
                    <div class="el-upload__tip" slot="tip">{{$t('validations.pictureSize')}}</div>
                  </el-upload>
                </div>
              </div>
            </form>
          </div>
        </div>

        <div class="card location-card width-50">
          <div class="card-content">
            <p>{{$t('settingCompany.smsoIntegration')}}</p>
            <hr class="sm">
            <form class="clearfix row">
              <div class="clearfix form-group">
                <div class="col-lg-8 col-md-8">
                  <label>{{$t('settingCompany.smsoToken')}}</label>
                  <input type="text" class="form-control" placeholder="zxQcP6vCIfMMjtrqxzLp1Pdfg1dKLx5D8StJmtgzno" v-model="model.smso_token"></input>
                </div>
                <div class="col-lg-4 col-md-4">
                  <label>{{$t('settingCompany.smsoSender')}}</label>
                  <input type="text" class="form-control" placeholder="420" v-model="model.smso_sender"></input>
                </div>
              </div>
              <div class="clearfix form-group">
                <div class="col-lg-8 col-md-8">
                  <label>{{$t('settingCompany.smsoTokenExtern')}}</label>
                  <input type="text" class="form-control" placeholder="zxQcP6vCIfMMjtrqxzLp1Pdfg1dKLx5D8StJmtgzno" v-model="model.smso_token_extern"></input>
                </div>
                <div class="col-lg-4 col-md-4">
                  <label>{{$t('settingCompany.smsoSenderExtern')}}</label>
                  <input type="text" class="form-control" placeholder="420" v-model="model.smso_sender_extern"></input>
                </div>
              </div>
            </form>
          </div>
        </div>

      </div>

      <div class="card-containerf1">
        <div class="card location-card width-50">
          <div class="card-content">
            <p>{{$t('settingCompany.pos')}}</p>
            <hr class="sm">
            <form class="clearfix">
              <div class="row">
                <div class="col-lg-6 col-md-6">
                  <div class="form-group">
                    <label>{{$t('settingCompany.use_pos_notifications')}}</label>
                    <br/>
                    <p-switch v-model="model.use_pos_notifications" type="success"></p-switch>
                  </div>
                </div>
                <div class="col-lg-6 col-md-6">
                  <div class="form-group">
                    <label>{{$t('settingCompany.use_clients_offline')}}</label>
                    <br/>
                    <p-switch v-model="model.use_clients_offline" type="success"></p-switch>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-6 col-md-6">
                  <div class="form-group">
                    <label>{{$t('settingCompany.use_gift_card_on_pos')}}</label>
                    <br/>
                    <p-switch v-model="model.use_gift_card_on_pos" type="success"></p-switch>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>

        <div class="card location-card width-50">
          <div class="card-content">
            <p>{{$t('settingCompany.app')}}</p>
            <hr class="sm">
            <form class="clearfix">
              <div class="row">
                <div class="col-lg-6 col-md-6">
                  <div class="form-group">
                    <label>{{$t('settingCompany.use_interactive_tour_first_login')}}</label>
                    <br/>
                    <p-switch v-model="model.use_interactive_tour_first_login" type="success"></p-switch>
                  </div>
                </div>
                <div class="col-lg-6 col-md-6">
                  <div class="form-group">
                    <label>{{$t('settingCompany.use_interactive_tour_always')}}</label>
                    <br/>
                    <p-switch v-model="model.use_interactive_tour_always" type="success"></p-switch>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-6 col-md-6">
                  <div class="form-group">
                    <label>{{$t('settingCompany.force_location_from_deeplink')}}</label>
                    <br/>
                    <p-switch v-model="model.force_location_from_deeplink" type="success"></p-switch>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Input} from 'element-ui'
  import swal from 'sweetalert2'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import FileInput from 'src/components/UIComponents/Inputs/FileInput.vue'
  // import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
  import DisplayQr from 'src/components/UIComponents/Inputs/DisplayQr.vue'
  import 'sweetalert2/dist/sweetalert2.css'

  // import {mapFields} from 'vee-validate'
  Vue.use(Input)

  export default {
    components: {
      [Input.name]: Input,
      PSwitch,
      // GeneralTopBar,
      FileInput,
      DisplayQr
    },
    props: {
      countries: {},
      modeldata: {},
      taxesData: {},
      tabRefresh: {},
      isCompanyDetails: {
        type: Boolean,
        default: false
      }
    },
    watch: {
      countries (value) {
        this.countriesList = value
      },
      modeldata (value) {
        this.showDelete = value.locations_details.length > 1
        this.model = value
        if (this.model.languages) {
          this.model.selected_languages = this.model.languages.map(lang => ({
            value: lang.id,
            label: lang.name
          }))
        }
        if (this.model.initial_order_status_app_web) {
          this.model.initial_order_status_app_web = this.orderStatusOptions.find(t => t.value === this.model.initial_order_status_app_web) || null
        }
        this.syncImageFileLists()
      },
      taxesData (value) {
        this.taxes = value
      },
      tabRefresh (value) {
        if (value === 'Company Details') {
          this.showUpdateWarning = false
          var data = {
            token: this.$session.get('token')
          }
          var self = this
          var companyID = this.$session.get('selectedCompany')

          this.apiRequest('/settings/general/' + companyID, 'GET', data, function (response) {
            if (response.status === true) {
              self.$emit('updateModelData', response.data[0])
            }
          })
        }
      }
    },
    data () {
      return {
        model: this.value || this.modeldata,
        sortMethodsList: [],
        taxes: this.value || this.taxesData,
        modelValidate: {
          name: {required: true},
          email: {required: true},
          phone: {required: true},
          number: {required: true},
          street: {required: true},
          city: {required: true},
          state: {required: true},
          country: {required: true},
          working_hours: {required: true},
          email_feedback: {required: true}
        },
        showUpdateWarning: false,
        languages: this.$session.get('defaultData')['available_languages'],
        dbLanguages: null,
        dbLanguagesOptions: null,
        windowHeight: 0,
        navbarHeaderHeight: 0,
        pageTopHeight: 76,
        loading: true,
        paymentGroups: null,
        deliveryMethods: [],
        imagelist: [],
        imagelistLogo: [],
        imagelistAppImage: [],
        menuType: [{'id': 0, 'label': 'PDF'}, {'id': 1, 'label': 'Dynamic'}],
        vatOptions: [],
        taxesVersion: Number((this.$session.get('selectedCompanyData') || {}).taxes_version || 1),
        selfOrderStatusOptions: [
          { label: 'NEW', value: null },
          { label: 'PROCESSING', value: 'PROCESSING' }
        ],
        orderStatusOptions: [
          // { label: this.$t('ordersStatus.NEW'), value: 'NEW' },
          { label: this.$t('ordersStatus.PROCESSING'), value: 'PROCESSING' }
        ]
      }
    },
    updated: function () {
    },
    created () {
      this.getData()
      this.syncImageFileLists()
    },
    computed: {
      initalOrderStatusKiosk: {
        get () {
          return this.selfOrderStatusOptions.find(t => t.value === this.model.initial_order_status_self_order) || this.selfOrderStatusOptions[0]
        },
        set (value) {
          this.$set(this.model, 'initial_order_status_self_order', value ? value.value : null)
        }
      },
      initalOrderStatusAppWeb: {
        get () {
          return this.orderStatusOptions.find(t => t.value === this.model.initial_order_status_app_web) || null
        },
        set (value) {
          this.model.initial_order_status_app_web = value ? value.initial_order_status_app_web : null
        }
      }
    },
    mounted () {
      this.getDbLanguages()
      this.getVatOptions()
      this.$nextTick(() => {
        this.doHeightCalculation()
        this.loading = false

        window.addEventListener('resize', () => {
          this.doHeightCalculation()
        })
      })
    },
    methods: {
      syncImageFileLists () {
        this.imagelistLogo = this.model.logo ? [{'url': this.model.logo}] : []
        this.imagelistAppImage = this.model.app_image ? [{'url': this.model.app_image}] : []
        this.imagelist = this.model.unavailable_image ? [{'url': this.model.unavailable_image}] : []
      },
      getDbLanguages () {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('/get-db-languages', 'GET', data, (response) => {
          if (response.status === true) {
            this.dbLanguages = response.data.languages
            this.dbLanguagesOptions = this.dbLanguages.map(lang => ({
              label: lang.name,
              value: lang.id
            }))
          }
        })
      },
      getVatOptions (locaitonIds = null) {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          location_ids: locaitonIds
        }
        const endpoint = this.taxesVersion === 2 ? '/taxes-v2/vat-rates' : '/location/vat'
        this.apiRequest(endpoint, 'GET', data, (response) => {
          if (response.status === true) {
            this.vatOptions = response.data
          }
        })
      },
      handleImgChnage (file, fileList) {
        // const isJPG = file.type === 'image/jpeg'
        const isOkSize = file.size / 1024 / 1024 < 5
        var self = this
        if (!isOkSize) {
          swal({
            toast: true,
            type: 'warning',
            text: self.$t('validations.pictureSizeExceed'),
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          }).then(() => {})
          .catch(() => {})
          this.$refs.upload.clearFiles()
          this.imagelist = []
        } else {
          if (fileList.length > 1) {
            this.imagelist = fileList.slice(1)
          } else {
            this.imagelist = fileList
          }
          if (this.imagelist && this.imagelist[0].status === 'ready') {
            this.getBase64(this.imagelist[0].raw).then(
              (base64enc) => {
                this.model.unavailable_image = base64enc
              }
            )
          }
        }
      },
      handleImgChangeLogo (file, fileList) {
        // const isJPG = file.type === 'image/jpeg'
        const isOkSize = file.size / 1024 / 1024 < 5
        var self = this
        if (!isOkSize) {
          swal({
            toast: true,
            type: 'warning',
            text: self.$t('validations.pictureSizeExceed'),
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          }).then(() => {})
          .catch(() => {})
          this.$refs.uploadLogo.clearFiles()
          this.imagelistLogo = []
        } else {
          if (fileList.length > 1) {
            this.imagelistLogo = fileList.slice(1)
          } else {
            this.imagelistLogo = fileList
          }
          if (this.imagelistLogo && this.imagelistLogo[0].status === 'ready') {
            this.getBase64(this.imagelistLogo[0].raw).then(
              (base64enc) => {
                this.model.logo = base64enc
              }
            )
          }
        }
      },
      handleRemove (file, fileList) {
        if (fileList.length === 0) {
          this.imagelist = []
          this.model.unavailable_image = ''
        }
      },
      handleRemoveLogo (file, fileList) {
        if (fileList.length === 0) {
          this.imagelistLogo = []
          this.model.logo = ''
        }
      },
      handleImgChangeAppImage (file, fileList) {
        const isOkSize = file.size / 1024 / 1024 < 5
        var self = this
        if (!isOkSize) {
          swal({
            toast: true,
            type: 'warning',
            text: self.$t('validations.pictureSizeExceed'),
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          }).then(() => {})
          .catch(() => {})
          this.$refs.uploadAppImage.clearFiles()
          this.imagelistAppImage = []
        } else {
          if (fileList.length > 1) {
            this.imagelistAppImage = fileList.slice(1)
          } else {
            this.imagelistAppImage = fileList
          }
          if (this.imagelistAppImage && this.imagelistAppImage[0].status === 'ready') {
            this.getBase64(this.imagelistAppImage[0].raw).then(
              (base64enc) => {
                this.model.app_image = base64enc
              }
            )
          }
        }
      },
      handleRemoveAppImage (file, fileList) {
        if (fileList.length === 0) {
          this.imagelistAppImage = []
          this.model.app_image = ''
        }
      },
      uploadImage (upload) {
      },
      handleExceed (files, fileList) {
        swal({
          text: 'Please remove the current file in order to be able to add a new one',
          type: 'warning',
          showConfirmButton: true
        })
      },
      beforeUpload (file) {
        const isOkSize = file.size / 1024 / 1024 < 5
        var self = this
        if (!isOkSize) {
          swal({
            toast: true,
            type: 'warning',
            title: self.$t('validations.pictureSizeExceed'),
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          }).then(() => {})
          .catch(() => {})
        }
        return isOkSize
      },
      getData () {
        this.deliveryMethods = this.getCompanyDetail('delivery_options_labels')
        this.timeFormat = this.getCompanyDetail('time_format')
        this.dateFormat = this.getCompanyDetail('date_format')
        this.sortMethodsList = this.$session.get('defaultData').sort_products_methods

        var self = this
        var data = {
          token: this.$session.get('token')
        }
        this.apiRequest('/settings/payment-groups/' + self.$session.get('selectedCompany'), 'GET', data, function (response) {
          if (response.status === true) {
            if (response.data.length === 0) {
              self.paymentGroups = null
            } else {
              self.paymentGroups = response.data
            }
          }
        })
      },
      checkVal (location) {
        // console.warn(location.allow_preorder)
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate (pageId) {
        this.$validator.validateAll().then(isValid => {
          if (isValid) {
            this.saveDetails(false, null)
          } else {
            // console.warn(this.errors)
          }
        })
      },
      doHeightCalculation () {
        this.windowHeight = window.innerHeight
        // this.navbarHeaderHeight = this.$refs.navbarHeader.clientHeight
      },
      disableTaxOption (locId, taxId) {
        let locIdx = this.getObjectByElemKeyValue('id', locId, this.model.locations_details)
        let thisTaxIdx = this.getObjectByElemKeyValue('id', taxId, this.model.locations_details[locIdx]['taxes'])

        if (thisTaxIdx !== false) {
          return true
        } else {
          return false
        }
      },
      scrollToPx (px) {
        // console.warn(px)
        var elem = this.$el
        // console.warn(elem.clientHeight)
        elem.scrollTop = elem.clientHeight
        window.scrollTo({
          left: 0,
          top: elem.clientHeight - px,
          behavior: 'smooth'
        })
      },
      saveDetails (isDel, locId) {
        this.$nextTick(function () { this.loading = true })
        var companyID = this.$session.get('selectedCompany')

        if (this.taxesVersion !== 2 && this.model.tips_taxes === null) {
          this.model.tips_taxes = []
        }
        if (this.model.alert_multiple_orders_per_hour < 5) {
          this.model.alert_multiple_orders_per_hour = null
        }
        if (this.model.alert_multiple_orders_per_hour > 500) {
          this.model.alert_multiple_orders_per_hour = 500
        }
        var data = {
          'token': this.$session.get('token'),
          'name': this.model.name,
          'language': this.model.language,
          'tips_in_use': this.model.tips_in_use ? 1 : 0,
          'tips_pos_id': this.model.tips_pos_id,
          'tips_department_id': this.model.tips_department_id,
          'email_feedback': this.model.email_feedback,
          'jump_to_menu': this.model.jump_to_menu ? 1 : 0,
          'over_eighteen': this.model.over_eighteen ? 1 : 0,
          'automated_processed_status': this.model.automated_processed_status ? 1 : 0,
          // 'donation_point_value': parseFloat(this.model.donation_point_value),
          'alert_multiple_orders_per_hour': parseInt(this.model.alert_multiple_orders_per_hour),
          'smso_sender': this.model.smso_sender,
          'smso_token': this.model.smso_token,
          'smso_sender_extern': this.model.smso_sender_extern,
          'smso_token_extern': this.model.smso_token_extern,
          'allow_order_until_close_hour': this.model.allow_order_until_close_hour ? 1 : 0,
          'sort_product_method': this.model.sort_product_method,
          'is_allowed_on_hold': this.model.is_allowed_on_hold ? 1 : 0,
          'is_allowed_postponed': this.model.is_allowed_postponed ? 1 : 0,
          'remove_totals_extras_from_discount': this.model.remove_totals_extras_from_discount ? 1 : 0,
          'print_fiscal_from_dashboard': this.model.print_fiscal_from_dashboard ? 1 : 0,
          'payment_btns_v2': this.model.payment_btns_v2 ? 1 : 0,
          'just_card_txt_to_kiosk': this.model.just_card_txt_to_kiosk ? 1 : 0,
          'add_packing_method_to_comment': this.model.add_packing_method_to_comment ? 1 : 0,
          'is_allowed_sound_at_new': this.model.is_allowed_sound_at_new ? 1 : 0,
          'is_allowed_sound_at_processing': this.model.is_allowed_sound_at_processing,
          'is_allowed_order_under_min_value': this.model.is_allowed_order_under_min_value ? 1 : 0,
          'use_order_grandtotal_for_shipping_discount': this.model.use_order_grandtotal_for_shipping_discount ? 1 : 0,
          'flag_fast_order_from_admin': this.model.flag_fast_order_from_admin ? 1 : 0,
          'sound_delivery_methods': this.model.sound_delivery_methods,
          'unavailable_text': this.model.unavailable_text,
          'unavailable_image': this.model.unavailable_image,
          'logo': this.model.logo,
          'app_image': this.model.app_image,
          'delivery_options_labels': JSON.stringify(this.model.delivery_options_labels),
          'selected_languages': this.model.selected_languages,
          'initial_order_status_self_order': this.model.initial_order_status_self_order === 'PROCESSING' ? 'PROCESSING' : null,
          'initial_order_status_app_web': this.model.initial_order_status_app_web ? this.model.initial_order_status_app_web.value : null,
          'purchase_limit_interval_hours': this.model.purchase_limit_interval_hours ? this.model.purchase_limit_interval_hours : null,
          'use_pos_notifications': this.model.use_pos_notifications ? 1 : 0,
          'use_clients_offline': this.model.use_clients_offline ? 1 : 0,
          'use_gift_card_on_pos': this.model.use_gift_card_on_pos ? 1 : 0,
          'use_interactive_tour_always': this.model.use_interactive_tour_always ? 1 : 0,
          'use_interactive_tour_first_login': this.model.use_interactive_tour_first_login ? 1 : 0,
          'force_location_from_deeplink': this.model.force_location_from_deeplink ? 1 : 0
        }

        if (this.taxesVersion === 2) {
          data.tips_vat_rate_id = this.model.tips_vat_rate_id || null
        } else {
          data.tips_taxes = JSON.stringify(this.model.tips_taxes)
        }

        var self = this
        this.apiRequest('/settings/general/' + companyID, 'PUT', data, function (response) {
          if (response.status === true) {
            self.trackAdminEvent('ADMIN_COMPANY_DETAILS_UPDATE', 'company', companyID, {
              company_id: companyID,
              name: data.name || null,
              request: data,
              response: response
            })
            self.$emit('updateModelData', response.data[0])
            self.$session.set('companyName', data.name)
            self.errors.clear()
            self.$nextTick(function () {
              self.loading = false
              self.syncCompanySessionAndCache(response.data[0])
            })
            swal({'text': self.$t('settingCompany.companyUpdated'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000}).catch(() => {})
            if (isDel) {
              // locId
              let filterCookie = self.$cookie.get('filter-locations')
              if (filterCookie) {
                filterCookie = JSON.parse(filterCookie)
                let indexOf = filterCookie.indexOf(locId)
                if (indexOf !== -1) {
                  filterCookie.splice(indexOf, 1)
                  self.$cookie.set('filter-locations', JSON.stringify(filterCookie), 30)
                }
              }
            }
            self.$emit('companyName', data.name)
            self.showDelete = self.model.locations_details.length > 1
          } else {
            self.$nextTick(function () { self.loading = false })
            if (response.errors.latlng !== undefined) {
              swal({'text': self.$t('settingCompany.wrongAddress', {location: response.errors.latlng}), 'type': 'error', 'showConfirmButton': true}).catch(() => {})
            } else {
              swal({'text': self.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000}).catch(() => {})
            }
          }
        })
      },
      goToCompany () {
        this.$emit('setSelectedTab', this.$t('settingsPages.taxLabeling'))
      },
      handleMenu (index, event) {
        this.model.locations_details[index].use_dynamic_menu = event.target.value
      }
    }
  }
</script>

<style scopped>
  .card-containerf1 {
    display: flex;
    justify-content: space-between;
    gap: 10px;
  }

  .flex-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .card.location-card {
    flex: 1;
    margin-left: 0px !important;
    /* margin-right: 10px !important; */
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Settings/Tabs/CompanyDetails.vue